export var IFramePlayerErrorCode;
(function (IFramePlayerErrorCode) {
    IFramePlayerErrorCode["P1000"] = "P1000";
    IFramePlayerErrorCode["P1001"] = "P1001";
    IFramePlayerErrorCode["P1002"] = "P1002";
    IFramePlayerErrorCode["P1010"] = "P1010";
    IFramePlayerErrorCode["P1011"] = "P1011";
})(IFramePlayerErrorCode || (IFramePlayerErrorCode = {}));
